/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolStraightenIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-straighten"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M1.4 19.95Q0.3 19.95 -0.47 19.18Q-1.25 18.4 -1.25 17.3L-1.25 6.7Q-1.25 5.6 -0.47 4.83Q0.3 4.05 1.4 4.05L5.38 4.05L5.38 10.68Q5.38 11.22 5.76 11.61Q6.15 12 6.7 12Q7.25 12 7.64 11.61Q8.03 11.22 8.03 10.68L8.03 4.05L10.68 4.05L10.68 10.68Q10.68 11.22 11.06 11.61Q11.45 12 12 12Q12.55 12 12.94 11.61Q13.32 11.22 13.32 10.68L13.32 4.05L15.97 4.05L15.97 10.68Q15.97 11.22 16.36 11.61Q16.75 12 17.3 12Q17.85 12 18.24 11.61Q18.63 11.22 18.63 10.68L18.63 4.05L22.6 4.05Q23.7 4.05 24.48 4.83Q25.25 5.6 25.25 6.7L25.25 17.3Q25.25 18.4 24.48 19.18Q23.7 19.95 22.6 19.95Z" fill={color} />
    </svg>
  );
}
